import { render } from "./AddPortletTemplateView.vue?vue&type=template&id=57bab936&scoped=true"
import script from "./AddPortletTemplateView.vue?vue&type=script&lang=js"
export * from "./AddPortletTemplateView.vue?vue&type=script&lang=js"

import "./AddPortletTemplateView.vue?vue&type=style&index=0&id=57bab936&scoped=true&lang=css"
import "./AddPortletTemplateView.vue?vue&type=style&index=1&id=57bab936&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bab936"]])

export default __exports__